/**
 * Splash Screen Component
 *
 * Displays the Dasher logo on brand background while the app initializes.
 * Shows during:
 * - Initial app load
 * - Auth state loading
 * - Protected route checks
 * - Service worker updates (with "Updating" message)
 */
export function SplashScreen() {
  // Check if this is an SW update reload (flag set in main.tsx before reload)
  const isUpdating = sessionStorage.getItem('sw-updating') === 'true';

  // Clear flag after reading so it only shows once
  if (isUpdating) {
    sessionStorage.removeItem('sw-updating');
  }

  return (
    <div className="fixed inset-0 bg-[#102217] flex items-center justify-center z-50">
      <div className="flex flex-col items-center gap-8 animate-fade-in">
        {/* Logo */}
        <img
          src="/Dasher.png"
          alt="Dasher"
          className="w-48 h-auto"
        />

        {/* Loading indicator with optional update message */}
        <div className="flex flex-col items-center gap-3">
          {isUpdating && (
            <p className="text-green-400 text-sm">Updating to latest version</p>
          )}
          <div className="flex gap-1.5">
            <div className="w-2 h-2 rounded-full bg-green-500 animate-bounce [animation-delay:-0.3s]" />
            <div className="w-2 h-2 rounded-full bg-green-500 animate-bounce [animation-delay:-0.15s]" />
            <div className="w-2 h-2 rounded-full bg-green-500 animate-bounce" />
          </div>
        </div>
      </div>
    </div>
  );
}
